import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { getData, paginate, filter } from './utils';
import '@cds/core/select/register.js';
let DemoPagination = class DemoPagination extends LitElement {
    constructor() {
        super(...arguments);
        this.data = getData();
        this.filteredList = [];
        this.search = '';
        this.currentPage = 0;
        this.pageSize = 10;
        this.pageCount = 1;
    }
    render() {
        return html `
      <cds-grid>
        <cds-grid-column>Stock</cds-grid-column>
        <cds-grid-column>Average</cds-grid-column>
        <cds-grid-column>Current</cds-grid-column>
        <cds-grid-column>About</cds-grid-column>
        ${this.filteredList.map(entry => html `
          <cds-grid-row>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>$${entry.average}</cds-grid-cell>
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer>
          <cds-pagination>
            <cds-select control-width="shrink" responsive="false">
              <label cds-layout="display:screen-reader-only">per page</label>
              <select @input=${e => this.pageSize = e.target.value} style="width: 46px">
                <option value="5">5</option>
                <option value="10" selected>10</option>
                <option value="15">15</option>
                <option value="25">25</option>
              </select>
            </cds-select>
            <cds-pagination-button ?disabled=${this.currentPage === 0} action="first" @click=${this.firstPage}></cds-pagination-button>
            <cds-pagination-button ?disabled=${this.currentPage === 0} action="prev" @click=${this.prevPage}></cds-pagination-button>
            <input type="number" @input=${this.setPage} .value=${this.currentPage + 1} min="1" max=${this.pageCount} aria-label="page number" /> / ${this.pageCount}
            <cds-pagination-button ?disabled=${this.currentPage === this.pageCount - 1} action="next" @click=${this.nextPage}></cds-pagination-button>
            <cds-pagination-button ?disabled=${this.currentPage === this.pageCount - 1} action="last" @click=${this.lastPage}></cds-pagination-button>
          </cds-pagination>
        </cds-grid-footer>
      </cds-grid>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateList();
    }
    updated(props) {
        super.updated(props);
        if ((props.has('currentPage') && props.get('currentPage') !== this.currentPage) ||
            (props.has('search') && props.get('search') !== this.search) ||
            (props.has('pageSize') && props.get('pageSize') !== this.pageSize)) {
            this.updateList();
        }
        if (props.has('search') && props.get('search') !== this.search) {
            this.firstPage();
        }
    }
    updateList() {
        var _a;
        let list = filter([...this.data], 'id', this.search);
        this.pageCount = Math.ceil(list.length / this.pageSize);
        this.filteredList = (_a = paginate(list, this.pageSize)[this.currentPage]) !== null && _a !== void 0 ? _a : [];
    }
    setPage(event) {
        this.currentPage = parseInt(event.target.value) - 1;
    }
    nextPage() {
        if (this.currentPage <= this.pageCount) {
            this.currentPage++;
        }
    }
    prevPage() {
        if (this.currentPage > 0) {
            this.currentPage--;
        }
    }
    firstPage() {
        this.currentPage = 0;
    }
    lastPage() {
        this.currentPage = Math.ceil(this.data.length / this.pageSize) - 1;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoPagination.prototype, "data", void 0);
__decorate([
    internalProperty()
], DemoPagination.prototype, "filteredList", void 0);
__decorate([
    internalProperty()
], DemoPagination.prototype, "search", void 0);
__decorate([
    internalProperty()
], DemoPagination.prototype, "currentPage", void 0);
__decorate([
    internalProperty()
], DemoPagination.prototype, "pageSize", void 0);
__decorate([
    internalProperty()
], DemoPagination.prototype, "pageCount", void 0);
DemoPagination = __decorate([
    customElement('demo-pagination')
], DemoPagination);
export { DemoPagination };
//# sourceMappingURL=demo.pagination.js.map